<div *ngIf="visib">
    <app-slider-image *ngIf="searchh.results" [listappeloffres]="searchh.results" [slides]='slides'></app-slider-image>

    <app-consulationcards *ngIf="listConsultations.results" [listconsultations]="listConsultations.results"
                          [slides]="slidesConsultation"></app-consulationcards>
    <app-statistiques></app-statistiques>
    <app-doclois></app-doclois>
    <app-serv-assistant></app-serv-assistant>
    <app-sitesutiles></app-sitesutiles>

</div>
